import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AttractionsFirestoreDocumentRequest } from '../../types';
import { responseHandler } from '../utils';

type MutationParams = {
    data: AttractionsFirestoreDocumentRequest;
    id: string | number;
};

// v3-updateAttraction (PUT, body `{id, data}`). Endpoint wraca 200 OD RAZU — tłumaczenia
// dorabia w tle trigger `v3-onAttractionUpdated`, więc lista pokazuje „Translating…"
// zamiast blokować zapis na czas wywołań do OpenAI (tak działało v2).
export const usePatchAttractionFirestore = (
  options?: UseMutationOptions<void, AxiosError, MutationParams>,
): UseMutationResult<void, AxiosError, MutationParams> => useMutation<void, AxiosError, MutationParams>({
  mutationFn: async ({ data, id }) => {
    const response = await axiosInstance.put(
      '/v3-updateAttraction',
      { id: String(id), data },
      { headers: { 'Content-Type': 'application/json' } },
    );

    return responseHandler(response);
  },
  ...options,
});
